import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const StyledLogoImg = styled.img`
	width: 100px;
	@media (max-width: 420px) {
		height: 90px;
		padding: 10px 0 10px 0;
	}
`;

export const StyledList = styled.ul`
	text-transform: uppercase;

	@media (max-width: 420px) {
		display: ${({ display }) => display || ""};
		margin-bottom: 20px;
		margin-top: 30px;
	}
`;

export const StyledItem = styled.li`
	font-size: ${(p) => p.theme.fontSizes.fs14};

	&:not(:last-child) {
		margin-right: 50px;
	}

	/* & {
		padding: 40px 0;
	} */

	@media (max-width: 420px) {
		margin-bottom: 30px;
		font-size: ${(p) => p.theme.fontSizes.fs18};

		&:not(:last-child) {
			margin-right: 0;
		}
	}
`;

export const StyledLink = styled(NavLink)`
	transition: 0.3s ease;
	& {
		padding: 40px 0;
	}

	:hover,
	:focus {
		color: ${(p) => p.theme.colors.hoverText};
		transition: 0.3s ease;
	}

	&.active {
		color: ${(p) => p.theme.colors.hoverText};
	}

	@media (max-width: 420px) {
		padding: 0;
	}
`;

/* -------------------------------- Языковая панель -------------------------------- */
export const LenguageSwichWrapper = styled.div`
	position: relative;
	cursor: pointer;
`;

export const LenguageSwichText = styled.p`
	font-size: ${(p) => p.theme.fontSizes.fs14};
	margin-right: 4px;
`;

export const LengDropMenu = styled.ul`
	position: absolute;
	top: 25px;
	right: 16px;
	width: 22px;
	z-index: 999;

	> li {
		font-size: ${(p) => p.theme.fontSizes.fs14};
		cursor: pointer;
		transition: all 0.25s ease-out;
		&:hover,
		:focus {
			color: ${(p) => p.theme.colors.hoverText};
		}
	}
`;
